import {useMutation} from '@apollo/react-hooks';

import type {
    CreateInvoiceFromQuote as CreateInvoiceFromQuoteMutation,
    CreateInvoiceFromQuoteVariables,
    InvoiceCreateFromQuoteInput,
} from 'nutshell-graphql-types';

import CREATE_INVOICE_FROM_QUOTE from '../mutations/create-invoice-from-quote.graphql';

export const useCreateInvoiceFromQuote = (): {
    createInvoiceFromQuote: (input: InvoiceCreateFromQuoteInput) => Promise<any>;
} => {
    const [createInvoiceFromQuote] = useMutation<
        CreateInvoiceFromQuoteMutation,
        CreateInvoiceFromQuoteVariables
    >(CREATE_INVOICE_FROM_QUOTE);

    return {
        createInvoiceFromQuote: (input: InvoiceCreateFromQuoteInput) => {
            return createInvoiceFromQuote({
                variables: {
                    input: {
                        ...input,
                    },
                },
            });
        },
    };
};
